import React from 'react';
import { getColorFromScheme } from '../../helpers/utils';

export default function Badge({ label, type, withDot }) {
  const color = getColorFromScheme(type);

  return (
    <div className={`inline-flex items-center rounded-md px-2 text-sm font-normal py-0.5 bg-${color}-200 text-${color}-800`}>
      {withDot && <div className={`w-1.5 h-1.5 mr-1 bg-${color}-600 rounded-full`} />}
      {label}
    </div>
  );
}
